module.exports = __webpack_public_path__ + "media/images/card_logos/discover-logo-7c97e34792ac7698083ad13012941926.jpeg";